"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _headlineLockup = require("@site/pattern-library-core/headline-lockup");
var _textLoop = _interopRequireDefault(require("../../../../elements/other/text-loop"));
var _paragraph = _interopRequireDefault(require("@site/pattern-library-core/paragraph"));
/**
 * Local Imports
 */

const HeadlineContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "HeadlineContainer",
  class: "pl-h1gi5ubz",
  vars: {
    "h1gi5ubz-2": [({
      color
    }) => color ?? 'initial']
  }
});
const CtaContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CtaContainer",
  class: "pl-c7godsh"
});

/**
 * TextLoopLockup Component.
 *
 * @param {Object} props The properties that define the TextLoopLockup component.
 * @param {string} props.words Words for the text loop, separated by '|'.
 * @param {string} props.heading Heading text.
 * @param {string} props.eyebrow Title text. If present, heading tag will be 'h3' instead of 'h2'.
 * @param {string} props.description Description text.
 * @param {string} props.textColor The color of the text.
 * @param {node} props.cta Call to action element.
 * @param {string} props.eyebrowTag Title HTML tag
 * @returns {React.ReactElement} A React element representing the TextLoopLockup.
 * @public
 */

function TextLoopLockup({
  words = 'joy|love|uniqueness|smiles|adventure',
  heading,
  eyebrow,
  description,
  textColor,
  cta,
  eyebrowTag,
  ...rest
}) {
  const HeadlineTag = eyebrowTag === 'h1' || !eyebrow ? 'h2' : 'h3';
  const wordsArray = words.split('|')?.map(word => word.trim());
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(HeadlineContainer, {
    color: textColor
  }, eyebrow && /*#__PURE__*/_react.default.createElement(_paragraph.default, {
    asType: "title",
    dataCy: "title",
    text: eyebrow,
    tag: eyebrowTag ?? 'h2'
  }), heading && /*#__PURE__*/_react.default.createElement(_headlineLockup.HeadlineString, (0, _extends2.default)({
    heading: heading
  }, rest, {
    headlineTag: HeadlineTag,
    headingDataCy: "headline"
  })), words && /*#__PURE__*/_react.default.createElement(HeadlineTag, null, /*#__PURE__*/_react.default.createElement(_textLoop.default, (0, _extends2.default)({
    dataCy: "loop-headline",
    words: wordsArray,
    textColor: textColor
  }, rest))), description && /*#__PURE__*/_react.default.createElement(_paragraph.default, {
    "data-cy": "description",
    text: description
  })), cta && /*#__PURE__*/_react.default.createElement(CtaContainer, {
    "data-cy": "cta-container"
  }, cta));
}
var _default = exports.default = TextLoopLockup;
TextLoopLockup.propTypes = {
  words: _propTypes.default.string,
  heading: _propTypes.default.string,
  eyebrow: _propTypes.default.string,
  description: _propTypes.default.string,
  textColor: _propTypes.default.string,
  cta: _propTypes.default.node,
  eyebrowTag: _propTypes.default.string
};